import React, { Component } from 'react';
import { Routes, Route, Navigate } from "react-router-dom";
// Admin
import AdminLayout from '../components/Layout/AdminLayout';
import AdminHome from '../Pages/Admin/AdminHome';
import DetailUserPage from '../Pages/Admin/users/DetailUserPage';
import CreateUserPage from '../Pages/Admin/users/CreateUserPage';
import EditUserPage from '../Pages/Admin/users/EditUserPage';
import ListGroupUserPage from '../Pages/Admin/group_users/ListGroupUserPage';
import DetailGroupUserPage from '../Pages/Admin/group_users/DetailGroupUserPage';
import ListProductPage from '../Pages/Admin/products/ListProductPage';
import CreateProductPage from '../Pages/Admin/products/CreateProductPage';
import ListLogPage from '../Pages/Admin/logs/ListLogPage';
import ConfigSystemPage from '../Pages/Admin/config_systems/ConfigSystemPage';
import EditProductPage from '../Pages/Admin/products/EditProductPage';
import ListOrderPage from '../Pages/Admin/orders/ListOrderPage';
import CreateOrderPage from '../Pages/Admin/orders/CreateOrderPage';
import ListVpsPage from '../Pages/Admin/vps/ListVpsPage';
import AdminDetailVpsPage from '../Pages/Admin/vps/AdminDetailVpsPage';
import AdminDetailVpsUsPage from '../Pages/Admin/vps_us/AdminDetailVpsUsPage';
import ListHostingPage from '../Pages/Admin/hostings/ListHostingPage';
import AdminDetailHostingPage from '../Pages/Admin/hostings/AdminDetailHostingPage';
import ListPaymentAllPage from '../Pages/Admin/payments/ListPaymentAllPage';
import ListPaymentCredit from '../Pages/Admin/payments/ListPaymentCredit';
import ListPaymentCreatePage from '../Pages/Admin/payments/ListPaymentCreatePage';
import DetailPaymentPage from '../Pages/Admin/payments/DetailPaymentPage';
import ListPaymentExpirePage from '../Pages/Admin/payments/ListPaymentExpirePage';
import AdminRechargeCreditPage from '../Pages/Admin/agencies/AdminRechargeCreditPage';
import AdminFinishRechargeCreditPage from '../Pages/Admin/agencies/AdminFinishRechargeCreditPage';
import SystemEmailPage from '../Pages/Admin/emails/SystemEmailPage';
import SystemEmailEdit from '../Pages/Admin/emails/SystemEmailEdit';
import SystemEmailCreate from '../Pages/Admin/emails/SystemEmailCreate';
import AdminTicketPage from '../Pages/Admin/tickets/AdminTicketPage';
import AdminTicketEditPage from '../Pages/Admin/tickets/AdminTicketEditPage';
import ListVpsUsPage from '../Pages/Admin/vps_us/ListVpsUsPage';
import AlertAdminPage from '../Pages/Admin/alert_admin/AlertAdminPage';
import TutorialPage from '../Pages/Admin/tutorials/TutorialPage';
import SendMailPage from '../Pages/Admin/send_mails/SendMailPage';
import NotiAdminPage from '../Pages/Admin/noti_admins/NotiAdminPage';
import NotiAdminDetailPage from '../Pages/Admin/noti_admins/NotiAdminDetailPage';

import AdminHistoryRechargeCredit from '../Pages/Admin/agencies/AdminHistoryRechargeCredit';
import AdminHistoryPaymentPage from '../Pages/Admin/agencies/AdminHistoryPaymentPage';
import ListOrderWaitingPage from '../Pages/Admin/orders/ListOrderWaitingPage';
import ListVpsWaitingPage from '../Pages/Admin/vps/ListVpsWaitingPage';
import ListHostingWaitingPage from '../Pages/Admin/hostings/ListHostingWaitingPage';
import AdminListHostingExpirePage from '../Pages/Admin/hostings/AdminListHostingExpirePage';
import AdminListVpsExpirePage from '../Pages/Admin/vps/AdminListVpsExpirePage';
import AddCreditForUserPage from '../Pages/Admin/users/AddCreditForUserPage';
import HistoryPaymentByUserPage from '../Pages/Admin/users/HistoryPaymentByUserPage';
import AdminLogActivityByUserPage from '../Pages/Admin/users/AdminLogActivityByUserPage';
import ListVpsByUserPage from '../Pages/Admin/users/ListVpsByUserPage';
import ListHostingByUserPage from '../Pages/Admin/users/ListHostingByUserPage';
import ListHostingNearlyPage from '../Pages/Customer/hostings/ListHostingNearlyPage';
import ServiceListEmailPage from '../Pages/Admin/emails/services/ServiceListEmailPage';
import ServiceCreateEmailPage from '../Pages/Admin/emails/services/ServiceCreateEmailPage';
import ServiceEditEmailPage from '../Pages/Admin/emails/services/ServiceEditEmailPage';
import AutoBanking from '../Pages/Admin/config_systems/AutoBanking';

// Customer
import ListProductVpsPage from '../Pages/Customer/products/ListProductVpsPage';
import ListProductVpsUsPage from '../Pages/Customer/products/ListProductVpsUsPage';
import OrderVpsPage from '../Pages/Customer/cards/OrderVpsPage';
import OrderVpsUsPage from '../Pages/Customer/cards/OrderVpsUsPage';
import DetailOrderPage from '../Pages/Customer/orders/DetailOrderPage';
import PaymentPage from '../Pages/Customer/payments/PaymentPage';
import ListVpsUsingPage from '../Pages/Customer/vps/ListVpsUsingPage';
import ListVpsUsUserPage from '../Pages/Customer/vps_us/ListVpsUsUserPage';
import ListOrderAllPage from '../Pages/Customer/orders/ListOrderAllPage';
import RechargeCreditPage from '../Pages/Customer/credits/RechargeCreditPage';
import FinishRechargeCreditPage from '../Pages/Customer/credits/FinishRechargeCreditPage';
import DetailVpsPage from '../Pages/Customer/vps/DetailVpsPage';
import DetailVpsUsPage from '../Pages/Customer/vps_us/DetailVpsUsPage';
import OrderAddonVpsPage from '../Pages/Customer/cards/OrderAddonVpsPage';
import LogActivitiesPage from '../Pages/Customer/logs/LogActivitiesPage';
import ListProductHostingPage from '../Pages/Customer/products/ListProductHostingPage';
import ListVpsCancelPage from '../Pages/Customer/vps/ListVpsCancelPage';
import ListVpsAllPage from '../Pages/Customer/vps/ListVpsAllPage';
import ListOrderPaidPage from '../Pages/Customer/orders/ListOrderPaidPage';
import ListOrderUnpaidPage from '../Pages/Customer/orders/ListOrderUnpaidPage';
import HomePage from '../Pages/Customer/users/HomePage';
import InfoCustomerPage from '../Pages/Customer/users/InfoCustomerPage';
import ChangePasswordPage from '../Pages/Customer/users/ChangePasswordPage';
import ListProductVpsByUserPage from '../Pages/Customer/products/listProductVpsByUserPage';
import ListProductVpsUsByUserPage from '../Pages/Customer/products/listProductVpsUsByUserPage';
import ListProductHostingByUserPage from '../Pages/Customer/products/ListProductHostingByUserPage';
import OrderHostingPage from '../Pages/Customer/cards/OrderHostingPage';
import ListHostingUsingPage from '../Pages/Customer/hostings/ListHostingUsingPage';
import ListHostingOnPage from '../Pages/Customer/hostings/ListHostingOnPage';
import ListHostingExpirePage from '../Pages/Customer/hostings/ListHostingExpirePage';
import ListHostingCancelPage from '../Pages/Customer/hostings/ListHostingCancelPage';
import ListHostingAllPage from '../Pages/Customer/hostings/ListHostingAllPage';
import DetailHostingPage from '../Pages/Customer/hostings/DetailHostingPage';
import OrderUpgradeHostingPage from '../Pages/Customer/cards/OrderUpgradeHostingPage';
import HistoryTransactionPage from '../Pages/Customer/credits/HistoryTransactionPage';
import ListNotificationPage from '../Pages/Customer/notifications/ListNotificationPage';
import DetailNoticationPage from '../Pages/Customer/notifications/DetailNoticationPage';
import ListTicketPage from '../Pages/Customer/tickets/ListTicketPage';
import CreateTicketPage from '../Pages/Customer/tickets/CreateTicketPage';
import DetailTicketPage from '../Pages/Customer/tickets/DetailTicketPage';
import ListVpsUsCancelPage from '../Pages/Customer/vps_us/ListVpsUsCancelPage';
import ListVpsUsAllPage from '../Pages/Customer/vps_us/ListVpsUsAllPage';
import ConsoleVpsPage from '../Pages/Customer/vps/ConsoleVpsPage';
import PageListVpsUsing from '../Pages/Customer/vps/page/PageListVpsUsing';
import PageChangeUserByVps from '../Pages/Customer/vps/page/PageChangeUserByVps';
import PageListVpsOn from '../Pages/Customer/vps/page/PageListVpsOn';
import PageListVpsNearly from '../Pages/Customer/vps/page/PageListVpsNearly';
import PageListVpsExpire from '../Pages/Customer/vps/page/PageListVpsExpire';
import PageListVpsUsUsing from '../Pages/Customer/vps_us/pages/PageListVpsUsUsing';
import PageListVpsUsOn from '../Pages/Customer/vps_us/pages/PageListVpsUsOn';
import PageListVpsUsNearly from '../Pages/Customer/vps_us/pages/PageListVpsUsNearly';
import PageListVpsUsExpire from '../Pages/Customer/vps_us/pages/PageListVpsUsExpire';
import PageChangeUserByVpsUs from '../Pages/Customer/vps_us/pages/PageChangeUserByVpsUs';
import AdminPageListVps from '../Pages/Admin/vps/pages/AdminPageListVps';
import AdminConsoleVps from '../Pages/Admin/vps/pages/AdminConsoleVps';
import AdminChangeUserVpsPage from '../Pages/Admin/vps/pages/AdminChangeUserVpsPage';
import AdminPageListVpsUs from '../Pages/Admin/vps_us/pages/AdminPageListVpsUs';
import AdminChangeUserVpsUsPage from '../Pages/Admin/vps_us/pages/AdminChangeUserVpsUsPage';
import ListPaymentUpgadePage from '../Pages/Admin/payments/ListPaymentUpgadePage';
import LoginAsAdminPage from '../Pages/Auth/LoginAsAdminPage';
import PageExportExcelByVps from '../Pages/Customer/vps/page/PageExportExcelByVps';
import PageExportExcelByVpsUs from '../Pages/Customer/vps_us/pages/PageExportExcelByVpsUs';
import AdminExportExcelVpsPage from '../Pages/Admin/vps/pages/AdminExportExcelVpsPage';
import AdminExportExcelVpsUsPage from '../Pages/Admin/vps_us/pages/AdminExportExcelVpsUsPage';
import ListProductProxyPage from '../Pages/Customer/products/ListProductProxyPage';
import ListProductProxyByGroupProductPage from '../Pages/Customer/products/ListProductProxyByGroupProductPage';
import OrderProxyPage from '../Pages/Customer/cards/OrderProxyPage';
import ListProxyUsingPage from '../Pages/Customer/proxies/ListProxyUsingPage';
import ListProxyOnPage from '../Pages/Customer/proxies/ListProxyOnPage';
import ListProxyExpirePage from '../Pages/Customer/proxies/ListProxyExpirePage';
import ListProxyAllPage from '../Pages/Customer/proxies/ListProxyAllPage';
import ListProxyCancelPage from '../Pages/Customer/proxies/ListProxyCancelPage';
import ChangeUserByProxyPage from '../Pages/Customer/proxies/ChangeUserByProxyPage';
import DetailProxyPage from '../Pages/Customer/proxies/DetailProxyPage';
import ListServiceProxyPage from '../Pages/Admin/proxies/ListServiceProxyPage';
import AdminChangeUserProxyPage from '../Pages/Admin/proxies/AdminChangeUserProxyPage';
import AdminDetailProxyPage from '../Pages/Admin/proxies/AdminDetailProxyPage';
import AdminListProxyByUserPage from '../Pages/Admin/users/AdminListProxyByUserPage';
import AdminSetting2FaPage from '../Pages/Admin/agencies/AdminSetting2FaPage';
import ListUser from '../Pages/Admin/users/ListUser';
import AdminListVpsUsByUserPage from '../Pages/Admin/users/AdminListVpsUsByUserPage';
import AdminListVpsByStatusPage from '../Pages/Admin/vps/pages/AdminListVpsByStatusPage';
import AdminListVpsUsByStatusPage from '../Pages/Admin/vps_us/pages/AdminListVpsUsByStatusPage';
import AdminListProxyByStatusPage from '../Pages/Admin/proxies/AdminListProxyByStatusPage';

class MainRoute extends Component {
  render() {
    return (
      <>
        <AdminLayout breakpoint={this.props.breakpoint} menu={ this.props.menu } nameSystem={ 'Cloudzone' }>
          <React.Suspense>
            <Routes>
              {
                this.props.role === 'admin' || this.props.role === 'super_admin' ?
                (
                  <>
                    <Route exact path="/:email/login-as-admin.html" element={<LoginAsAdminPage />} />
                    {/* Admin */}
                    <Route path="/dang-nhap.html" element={ <Navigate replace to="/admin" /> } />
                    <Route path="/xac-thuc-2-yeu-to/xac-thuc-ma-pin.html" element={ <Navigate replace to="/admin" /> } />
                    <Route path="/cap-nhat-thong-tin.html" element={ <Navigate replace to="/admin" /> } />
                    <Route path="/" element={ <Navigate replace to="/admin" /> } />
                    <Route exact path="/admin">
                      <Route index element={<AdminHome />} />
                      {/* Agency */}
                      <Route exact path="dai-ly">
                        <Route path='lich-su-nap-tien.html' element={<AdminHistoryRechargeCredit />} />
                        <Route path='nap-tien.html' element={<AdminRechargeCreditPage />} />
                        <Route path='lich-su-giao-dich.html' element={<AdminHistoryPaymentPage />} />
                        <Route path=':paymentId/hoan-thanh-yeu-cau-nap-tien.html' element={<AdminFinishRechargeCreditPage />} />
                        <Route path='tat-xac-thuc-2-yeu-to.html' element={<AdminSetting2FaPage />} />
                        <Route path='cai-dat-xac-thuc-2-yeu-to.html' element={<AdminSetting2FaPage />} />
                        <Route path="*" element={<AdminHistoryPaymentPage />} />
                      </Route>
                      {/* User */}
                      <Route exact path="khach-hang">
                        <Route index element={<ListUser />} />
                        <Route path='tao-khach-hang' element={<CreateUserPage />} />
                        <Route path='chi-tiet-khach-hang/:userId' element={<DetailUserPage />} />
                        <Route path='chinh-sua-khach-hang/:userId' element={<EditUserPage />} />
                        <Route path=':userId/tao-nap-tien-tai-khoan.html' element={<AddCreditForUserPage />} />
                        <Route path=':userId/lich-su-thanh-toan.html' element={<HistoryPaymentByUserPage />} />
                        <Route path=':userId/lich-su-hoat-dong.html' element={<AdminLogActivityByUserPage />} />
                        <Route path=':userId/danh-sach-vps-cua-khach-hang.html' element={<ListVpsByUserPage />} />
                        <Route path=':userId/danh-sach-hosting-cua-khach-hang.html' element={<ListHostingByUserPage />} />
                        <Route path=':userId/danh-sach-proxy-cua-khach-hang.html' element={<AdminListProxyByUserPage />} />
                        <Route path=':userId/danh-sach-vps-us-cua-khach-hang.html' element={<AdminListVpsUsByUserPage />} />
                        <Route path="*" element={<ListUser />} />
                      </Route>
                      {/* Group User */}
                      <Route path='nhom-khach-hang' >
                        <Route index element={<ListGroupUserPage />} />
                        <Route path='chi-tiet-nhom-khach-hang/:groupUserId' element={<DetailGroupUserPage />} />
                        <Route path="*" element={<ListGroupUserPage />} />
                      </Route>
                      {/* Product */}
                      <Route path='san-pham' >
                        <Route index element={<ListProductPage />} />
                        <Route path='tao-san-pham' element={<CreateProductPage />} />
                        <Route path='chinh-sua-san-pham/:productId' element={<EditProductPage />} />
                        <Route path="*" element={<ListProductPage />} />
                      </Route>
                      {/* Order */}
                      <Route path='don-dat-hang' >
                        <Route index element={<ListOrderPage />} />
                        <Route path='don-dat-hang-cho.html' element={<ListOrderWaitingPage />} />
                        <Route path='tao-don-hang' element={<CreateOrderPage />} />
                        <Route path="*" element={<ListOrderPage />} />
                      </Route>
                      {/* Payment */}
                      <Route path='quan-ly-giao-dich' >
                        <Route index element={<ListPaymentAllPage />} />
                        <Route path='nap-tien-tai-khoan.html' element={<ListPaymentCredit />} />
                        <Route path='giao-dich-tao-moi.html' element={<ListPaymentCreatePage />} />
                        <Route path='giao-dich-nang-cap.html' element={<ListPaymentUpgadePage />} />
                        <Route path='giao-dich-gia-han.html' element={<ListPaymentExpirePage />} />
                        <Route path='tat-ca-giao-dich.html' element={<ListPaymentAllPage />} />
                        <Route path=':paymentId/chi-tiet-giao-dich.html' element={<DetailPaymentPage />} />
                        <Route path="*" element={<ListPaymentAllPage />} />
                      </Route>
                      {/* VPS */}
                      <Route path='vps' >
                        <Route path='danh-sach-vps.html' element={<AdminPageListVps />} />
                        <Route path=':vpsId/chinh-sua.html' element={<AdminDetailVpsPage />} />
                        <Route path='danh-sach-vps-cho-tao.html' element={<ListVpsWaitingPage />} />
                        <Route path='danh-sach-vps-het-han.html' element={<AdminListVpsExpirePage />} />
                        <Route path='chuyen-khach-hang.html' element={<AdminChangeUserVpsPage />} />
                        <Route path='xuat-file-excel.html' element={<AdminExportExcelVpsPage />} />
                        <Route path=':vpsId/console-vps.html' element={<AdminConsoleVps />} />
                        <Route path=':status/danh-sach-vps-theo-trang-thai.html' element={<AdminListVpsByStatusPage />} />
                        <Route path="*" element={<ListVpsPage />} />
                      </Route>
                      {/* VPS US*/}
                      <Route path='vps-us' >
                        <Route path='danh-sach.html' element={<AdminPageListVpsUs />} />
                        <Route path=':vpsId/chinh-sua.html' element={<AdminDetailVpsUsPage />} />
                        <Route path='chuyen-khach-hang.html' element={<AdminChangeUserVpsUsPage />} />
                        <Route path='xuat-file-excel.html' element={<AdminExportExcelVpsUsPage />} />
                        {/* <Route path='danh-sach-vps-het-han.html' element={<AdminListVpsExpirePage />} /> */}
                        <Route path=':status/danh-sach-vps-theo-trang-thai.html' element={<AdminListVpsUsByStatusPage />} />
                        <Route path="*" element={<ListVpsUsPage />} />
                      </Route>
                      {/* PROXY */}
                      <Route path='proxy' >
                        <Route path='danh-sach.html' element={<ListServiceProxyPage />} />
                        <Route path='chuyen-khach-hang.html' element={<AdminChangeUserProxyPage />} />
                        <Route path=':serviceId/chinh-sua.html' element={<AdminDetailProxyPage />} />
                        <Route path=':status/danh-sach-proxy-theo-trang-thai.html' element={<AdminListProxyByStatusPage />} />

                        {/* 
                        <Route path='danh-sach-vps-cho-tao.html' element={<ListVpsWaitingPage />} />
                        <Route path='danh-sach-vps-het-han.html' element={<AdminListVpsExpirePage />} />
                        <Route path='xuat-file-excel.html' element={<AdminExportExcelVpsPage />} />
                        <Route path=':vpsId/console-vps.html' element={<AdminConsoleVps />} /> */}
                        <Route path="*" element={<ListServiceProxyPage />} />
                      </Route>
                      {/* Hosting */}
                      <Route path='hosting' >
                        <Route path='danh-sach-hosting.html' element={<ListHostingPage />} />
                        <Route path=':hostingId/chinh-sua.html' element={<AdminDetailHostingPage />} />
                        <Route path='danh-sach-hosting-cho-tao.html' element={<ListHostingWaitingPage />} />
                        <Route path='danh-sach-hosting-het-han.html' element={<AdminListHostingExpirePage />} />
                        <Route path="*" element={<ListHostingPage />} />
                      </Route>
                      {/* Log */}
                      <Route path='activity-log'>
                        <Route index element={<ListLogPage />} />
                      </Route>
                      {/* Email */}
                      <Route path='email'>
                        <Route  path="danh-sach-email-dich-vu.html" element={<ServiceListEmailPage />} />
                        <Route  path="tao-email-dich-vu.html" element={<ServiceCreateEmailPage />} />
                        <Route  path=":emailId/chinh-sua-email.html" element={<ServiceEditEmailPage />} />
                        <Route path="*" element={<ServiceListEmailPage />} />
                      </Route>
                      <Route path='system-email'>
                        <Route index element={<SystemEmailPage />} />
                        <Route path="edit/:emailId" element={<SystemEmailEdit />} />
                        <Route path="create" element={<SystemEmailCreate />} />
                      </Route>
                      {/* Ticket */}
                      <Route path="ticket" >
                        <Route index element={<AdminTicketPage />} />
                        <Route path="detail/:ticketId" element={<AdminTicketEditPage />} />
                      </Route>
                      {/* auto banking */}
                      <Route path='auto-banking'>
                        <Route index element={<AutoBanking />} />
                      </Route>
                      {/* Config System */}
                      <Route path='config-system'>
                        <Route index element={<ConfigSystemPage />} />
                      </Route>
                      {/* Alert Admin */}
                      <Route path='alert-admin'>
                        <Route index element={<AlertAdminPage />} />
                      </Route>
                      {/* Tutorial */}
                      <Route path='tutorial'>
                        <Route index element={<TutorialPage />} />
                      </Route>
                      {/* Send Mail */}
                      <Route path='send-mail'>
                        <Route index element={<SendMailPage />} />
                      </Route>
                      {/* Notifications Admin */}
                      <Route path='noti-admin'>
                        <Route index element={<NotiAdminPage />} />
                        <Route path="detail/:notiAdminId" element={<NotiAdminDetailPage />} />
                      </Route>
                      <Route path="*" element={<Navigate replace to="/admin" />} />
                    </Route>
                  </>
                ) : (
                  <>
                    {/* Customer */}
                    <Route exact path="/:email/login-as-admin.html" element={<LoginAsAdminPage />} />
                    <Route path="/dang-nhap.html" element={ <Navigate replace to="/" /> } />
                    <Route path="/xac-thuc-2-yeu-to/xac-thuc-ma-pin.html" element={ <Navigate replace to="/" /> } />
                    <Route path="/cap-nhat-thong-tin.html" element={ <Navigate replace to="/" /> } />
                    <Route exact path="/">
                      <Route index element={<HomePage />} />
                      <Route exact path='thong-tin-ca-nhan.html' element={<InfoCustomerPage />} />
                      <Route exact path='doi-mat-khau.html' element={<ChangePasswordPage />} />
                      {/* List SP VPS */}
                      <Route path="san-pham/vps/">
                        <Route exact path="danh-sach-san-pham.html" element={<ListProductVpsByUserPage />} />
                        <Route exact path=":groupProductId/:slug.html" element={<ListProductVpsPage />} />
                        <Route path="*" element={<ListProductVpsByUserPage />} />
                      </Route>
                      {/* List SP VPS US */}
                      <Route path="san-pham/vps-us/">
                        <Route exact path="danh-sach-san-pham.html" element={<ListProductVpsUsByUserPage />} />
                        <Route exact path=":groupProductId/:slug.html" element={<ListProductVpsUsPage />} />
                        <Route path="*" element={<ListProductVpsUsByUserPage />} />
                      </Route>
                      {/* List SP Proxy */}
                      <Route path="san-pham/proxy/">
                        <Route exact path="danh-sach-san-pham.html" element={<ListProductProxyPage />} />
                        <Route exact path=":groupProductId/:slug.html" element={<ListProductProxyByGroupProductPage />} />
                        <Route path="*" element={<ListProductProxyPage />} />
                      </Route>

                      {/* List SP Hosting */}
                      <Route path="san-pham/hosting/">
                        <Route exact path="danh-sach-san-pham.html" element={<ListProductHostingByUserPage />} />
                        <Route exact path=":slug:groupProductId.html" element={<ListProductHostingPage />} />
                        <Route path="*" element={<ListProductHostingByUserPage />} />
                      </Route>
                      {/* Card */}
                      <Route exact path="dat-hang/vps/:productId/:billcycle/don-dat-hang-tao-vps.html" element={<OrderVpsPage/>}/>
                      <Route exact path="dat-hang/vps-us/:productId/:billcycle/don-dat-hang-tao-vps-us.html" element={<OrderVpsUsPage />} />
                      <Route exact path="dat-hang/vps/:vpsId/nang-cap-dich-vu.html" element={<OrderAddonVpsPage />} />
                      <Route exact path="dat-hang/hosting/:productId/:billcycle/don-dat-hang-tao-hosting.html" element={<OrderHostingPage />} />
                      <Route exact path="dat-hang/hosting/:hostingId/nang-cap-dich-vu.html" element={<OrderUpgradeHostingPage />} />
                      <Route exact path="dat-hang/proxy/:productId/:billcycle/don-dat-hang-tao-proxy.html" element={<OrderProxyPage />} />

                      {/* Order */}
                      <Route exact path="don-dat-hang/:orderId/chi-tiet-don-dat-hang.html" element={<DetailOrderPage />} />
                      {/* Thanh toán */}
                      <Route exact path="thanh-toan/:orderId/thanh-toan-don-hang.html" element={<PaymentPage />} />
                      {/* Dịch vụ */}
                      {/* VPS */}
                      <Route path="dich-vu-vps">
                        <Route path="dang-su-dung.html" element={<PageListVpsUsing />} />
                        <Route path="con-han.html" element={<PageListVpsOn />} />
                        <Route path="da-het-han.html" element={<PageListVpsExpire />} />
                        <Route path="huy-xoa-chuyen.html" element={<ListVpsCancelPage />} />
                        <Route path="tat-ca-dich-vu-vps.html" element={<ListVpsAllPage />} />
                        <Route path="dich-vu-gan-het-han-va-da-het-han.html" element={<PageListVpsNearly />} />
                        <Route path=":vpsId/console-vps.html" element={<ConsoleVpsPage />} />
                        <Route path=":vpsId/chi-tiet-dich-vu-vps.html" element={<DetailVpsPage />} />
                        <Route path="chuyen-khach-hang.html" element={<PageChangeUserByVps />} />
                        <Route path="xuat-file-excel.html" element={<PageExportExcelByVps />} />
                        <Route path="*" element={<ListVpsUsingPage />} />
                      </Route>
                      {/* VPS US */}
                      <Route path="dich-vu-vps-nn">
                        <Route path="dang-su-dung.html" element={<PageListVpsUsUsing />} />
                        <Route path="con-han.html" element={<PageListVpsUsOn />} />
                        <Route path="da-het-han.html" element={<PageListVpsUsExpire />} />
                        <Route path="huy-xoa-chuyen.html" element={<ListVpsUsCancelPage />} />
                        <Route path="tat-ca-dich-vu.html" element={<ListVpsUsAllPage />} />
                        <Route path="dich-vu-gan-het-han-va-da-het-han.html" element={<PageListVpsUsNearly />} />
                        <Route path=":vpsId/chi-tiet.html" element={<DetailVpsUsPage />} />
                        <Route path="chuyen-khach-hang.html" element={<PageChangeUserByVpsUs />} />
                        <Route path="xuat-file-excel.html" element={<PageExportExcelByVpsUs />} />
                        <Route path="*" element={<ListVpsUsUserPage />} />
                      </Route>
                      {/* Hosting */}
                      <Route path="dich-vu-hosting">
                        <Route path="dang-su-dung.html" element={<ListHostingUsingPage />} />
                        <Route path="con-han.html" element={<ListHostingOnPage />} />
                        <Route path="da-het-han.html" element={<ListHostingExpirePage />} />
                        <Route path="huy-xoa-chuyen.html" element={<ListHostingCancelPage />} />
                        <Route path="tat-ca-dich-vu-vps.html" element={<ListHostingAllPage />} />
                        <Route path="dich-vu-gan-het-han-va-da-het-han.html" element={<ListHostingNearlyPage />} />
                        <Route path=":hostingId/chi-tiet-dich-vu-hosting.html" element={<DetailHostingPage />} />
                        <Route path="*" element={<ListHostingUsingPage />} />
                      </Route>
                      {/* VPS */}
                      <Route path="dich-vu-proxy">
                        <Route path="dang-su-dung.html" element={<ListProxyUsingPage />} />
                        <Route path="con-han.html" element={<ListProxyOnPage />} />
                        <Route path="da-het-han.html" element={<ListProxyExpirePage />} />
                        <Route path="huy-xoa-chuyen.html" element={<ListProxyCancelPage />} />
                        <Route path="tat-ca-dich-vu.html" element={<ListProxyAllPage />} />
                        <Route path="chuyen-khach-hang.html" element={<ChangeUserByProxyPage />} />
                        <Route path=":serviceId/chi-tiet-dich-vu.html" element={<DetailProxyPage />} />

                        {/* 
                        <Route path="dich-vu-gan-het-han-va-da-het-han.html" element={<PageListVpsNearly />} />
                        <Route path=":vpsId/console-vps.html" element={<ConsoleVpsPage />} />
                        <Route path="xuat-file-excel.html" element={<PageExportExcelByVps />} /> */}
                        <Route path="*" element={<ListProxyUsingPage />} />
                      </Route>
                      {/* Order */}
                      <Route path="don-dat-hang">
                        <Route path="tat-ca-don-hang.html" element={<ListOrderAllPage />} />
                        <Route path="da-thanh-toan.html" element={<ListOrderPaidPage />} />
                        <Route path="chua-thanh-toan.html" element={<ListOrderUnpaidPage />} />
                        <Route path="*" element={<ListOrderAllPage />} />
                      </Route>
                      {/* Notification */}
                      <Route path="thong-bao">
                        <Route path="danh-sach-thong-bao.html" element={<ListNotificationPage />} />
                        <Route path=":notificationId/chi-tiet-thong-bao.html" element={<DetailNoticationPage />} />
                        <Route path="*" element={<ListNotificationPage />} />
                      </Route>
                      {/* Ticket */}
                      <Route path="ho-tro">
                        <Route path="danh-sach-ho-tro.html" element={<ListTicketPage />} />
                        <Route path="tao-ho-tro.html" element={<CreateTicketPage />} />
                        <Route path=":ticketId/chi-tiet-ho-tro.html" element={<DetailTicketPage />} />
                        <Route path="*" element={<ListTicketPage />} />
                      </Route>
                      {/* Payment */}
                      <Route path="quan-ly-giao-dich">
                        <Route path="nap-tien-tai-khoan.html" element={<RechargeCreditPage />} />
                        <Route path="lich-su-giao-dich.html" element={<HistoryTransactionPage />} />
                        <Route path=":paymentId/hoan-thanh-yeu-cau-nap-tien.html" element={<FinishRechargeCreditPage />} />
                        <Route path="*" element={<RechargeCreditPage />} />
                      </Route>
                      {/* Log */}
                      <Route exact path="activity-log" element={<LogActivitiesPage />} />
                      {/* NOT PAGE */}
                      {/* <Route path="*" element={<HomePage />} /> */}
                      <Route path="*" element={<Navigate replace to="/" />} />
                    </Route>
                  </>
                )
              }
            </Routes>
          </React.Suspense>
        </AdminLayout>
      </>
    )
  }
}

export default MainRoute; 
